<template>
  <div class="otp-activation-form">
    <section v-if="!isRegisteredSuccessfully" class="d-flex flex-column mt-sm-0 mt-xxs-5 mx-auto">
      <header class="d-sm-block d-xxs-none py-5 text-success">
        <h5>{{ $t(inputType.activationType) }}</h5>
      </header>
      <section class="pin-input d-flex flex-column">
        <pinInput ref="pinInput" :show-pin-error="pinIsNotValid" />
        <b-button
          variant="success"
          size="lg"
          class
          @click="checkPin"
        >
          {{ $t('security.confirmPinButtonText') }}
        </b-button>
        <b-button
          v-if="showResendButton"
          variant="secondary"
          size="sm"
          class="d-sm-block d-xxs-none mt-2"
          @click="resendPin"
        >
          {{ $t('security.reSendPin') }}
        </b-button>
        <small v-else class="text-secondary align-self-center my-3">
          {{ $t("security.reSendPinCounter",{counter:counter}) }}
        </small>
      </section>
      <footer class="footer d-flex flex-sm-column flex-xxs-row justify-content-around pt-5">
        <b-link
          href="#"
          class="text-secondary pt-sm-4 pt-xxs-0 text-decoration-none"
          @click="changePhoneNumber()"
        >
          <small>{{ $t(inputType.changePhoneOrEmail) }}</small>
        </b-link>
        <div class="line d-sm-block d-xxs-none mt-5 w-75" />
        <b-link
          v-if="showResendButton"
          class="text-white d-sm-none d-xxs-block text-decoration-none"
          @click="resendPin"
        >
          {{ $t('security.reSendPin') }}
        </b-link>
        <small v-else class="text-secondary align-self-center my-3 d-sm-none d-xxs-block">
          {{ $t("security.reSendPinCounter",{counter:counter}) }}
        </small>
        <!-- <ErrorBox v-if="serverErrorMessage" :errorMessage="serverErrorMessage"></ErrorBox> -->
      </footer>
    </section>
    <section
      v-else
      class="registered-successfully d-flex flex-column align-items-stretch mt-5 pt-xxs-5 pt-sm-0"
    >
      <header class="py-5 text-success">
        <h5 class="success-header font-weight-bold">
          {{ $t("register.registerSuccessfully") }}
        </h5>
      </header>
      <p
        class="font-weight-bold"
      >
        {{ $t("register.registerSuccessfulMessage",{tenantName:portalGeneralInfo.title}) }}
      </p>

      <b-button
        class="border font-weight-bold my-5"
        variant="success"
        size="lg"
        :to="{name:'login'}"
      >
        {{ $t("activedSuccessfully.loginToPortal") }}
      </b-button>
    </section>
    <div v-if="isRegisteredSuccessfully" class="pyro">
      <div class="before" />
      <div class="after" />
    </div>
  </div>
</template>

<script>
import pinInput from '@/components/PinInput.vue'
import { mapActions, mapGetters } from 'vuex'
import ErrorBox from '@/components/ErrorBox.vue'

export default {
  name: 'OtpActivationForm',
  components: {
    pinInput,
    ErrorBox
  },
  computed: {
    ...mapGetters({
      routeName: 'order/routeName',
      portalConfigurations: 'tenantDesign/config'
    }),
    pinInput () {
      return this.$refs.pinInput
    },
    pin () {
      return this.pinInput.pin
    },
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  props: {
    inputType: {},
    isRegisteredSuccessfully: Boolean,
    serverErrorMessage: String
  },
  data () {
    return {
      showResendButton: false,
      counter: 60,
      pinIsNotValid: false,
      changePhoneOrEmail: 'security.changePhoneNumber',
      model: {
        pin: ''
      }
    }
  },
  mounted () {
    this.setIntervalCount()
  },
  methods: {
    checkPin () {
      this.pinIsNotValid = this.pin.length < 4
      if (this.pinIsNotValid) return

      this.$emit('CheckPin', this.pin)
    },
    resendPin () {
      this.setIntervalCount()
      this.$emit('resendPin')
    },
    changePhoneNumber () {
      this.$router.push({ name: this.routeName })
    },
    setIntervalCount (showCounter) {
      this.showResendButton = false
      let intervalId = setInterval(() => {
        --this.counter
        if (this.counter === 0) {
          this.showResendButton = true
          this.counter = 60
          clearInterval(intervalId)
        }
      }, 1000)
    }
  }
}
</script>
